module.exports = __webpack_public_path__ + "static/quem-somos-md-9ccfcc09386d28d7866d8422e990e24c.png";